import { useEffect, useRef } from 'react';
import { NO_DRAFT } from 'app/api/draft-queries';

export function useResetOnDraftDiscard(draftData: unknown, reset: () => void): void {
  const hadDraftRef = useRef(false);
  const resetRef = useRef(reset);
  resetRef.current = reset;

  useEffect(() => {
    const hasDraft = draftData !== undefined && draftData !== null && draftData !== NO_DRAFT;
    if (hadDraftRef.current && !hasDraft) {
      resetRef.current();
    }
    hadDraftRef.current = hasDraft;
  }, [draftData]);
}
